import { render, staticRenderFns } from "./ModalProgramCompany.vue?vue&type=template&id=461ca125&scoped=true"
import script from "./ModalProgramCompany.vue?vue&type=script&lang=js"
export * from "./ModalProgramCompany.vue?vue&type=script&lang=js"
import style0 from "./ModalProgramCompany.vue?vue&type=style&index=0&id=461ca125&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461ca125",
  null
  
)

export default component.exports